const gql = require("graphql-tag");

const DEVICE_TOPIC_RUNNED = gql`
  subscription($id: ID) {
    DevicetopicRunned(id: $id) {
      id
      name
      type
      description
      isActive
      isConnect
      topic {
        id
        name
        type
        value
        minvalue
        maxvalue
        description
      }
    }
  }
`;

export const devicetopicSubscriptions = {
  DEVICE_TOPIC_RUNNED,
};
